import React from 'react';

import styled from 'styled-components';
import { Sad } from '@styled-icons/boxicons-regular';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';
import { useSubscriptionInfo } from '../../api';

import * as colors from '../../api/style';

import { FlatButtonLink } from '../common/Link';
import { noDesktop } from '../../style/constants';

export const BecomeProButton = () => (
  <ActiveProButton href="mailto:hello@virpp.com">Contact Sales</ActiveProButton>
);

export const BecomeProButtonIcon = (
  props: React.ImgHTMLAttributes<HTMLImageElement>,
) => <img src="/static/images/pro.png" alt="pro" height={12} {...props} />;

export const ExProBanner = () => {
  const { t } = useTranslation('subscriptions');
  return (
    <Container>
      <div className="content">
        <div className="title_container">
          <Sad size={15} color={colors.error_new} />
          &nbsp;
          <h4>{t('subscriptions:myTracks.exProBanner.title') as string}</h4>
        </div>
        <p>
          <Trans i18nKey="subscriptions:myTracks.exProBanner.body" />
        </p>
      </div>
      <div className="actions_container">
        <div className="action_container">
          <BecomeProButton />
          <BecomeProButtonIcon />
        </div>
      </div>
    </Container>
  );
};

const ActiveProButton = styled(FlatButtonLink)`
  color: #fff;
  background: transparent linear-gradient(165deg, #fd004c 0%, #2b85ff 100%) 0%
    0% no-repeat padding-box;
`;

const Container = styled.div`
  padding: 14px 28px 18px 18px;
  background: ${colors.grey_light_1_new};
  border: 1px solid ${colors.grey_light_2_new};
  display: flex;
  flex-wrap: wrap;

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;

    @media ${noDesktop} {
      text-align: center;
      flex: 0 0 100%;
      margin-bottom: 18px;
    }
  }

  .title_container {
    display: flex;
    align-items: center;
    margin-bottom: 6px;

    @media ${noDesktop} {
      justify-content: center;
    }

    h4 {
      color: ${colors.error_new};
      font-size: 14px;
      font-weight: 500;
      margin: 0px 0px 6px 0px;
      margin-bottom: 0;
    }

    p {
      color: ${colors.black_new};
      font-size: 14px;
      font-weight: 400;
      margin: 0;
    }
  }

  .actions_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 72px;

    @media ${noDesktop} {
      flex: 0 0 100%;
      margin-left: 0;
    }

    .action_container {
      display: flex;
      flex-direction: column;
      align-items: center;

      a {
        margin-bottom: 8px;
      }
    }
  }
`;

export const RenewButton = () => (
  <ActiveProButton href="mailto:hello@virpp.com">Contact Sales</ActiveProButton>
);

export const RenewBanner = () => {
  const { expiresInDays } = useSubscriptionInfo();
  const { t } = useTranslation();
  return (
    <Container>
      <div className="content">
        <div className="title_container">
          <h4>
            {t('subscriptions:my tracks.renew banner.title', {
              days: expiresInDays,
            })}
          </h4>
        </div>
        <p>
          <Trans i18nKey="subscriptions:my tracks.renew banner.body" />
        </p>
      </div>
      <div className="actions_container">
        <div className="action_container">
          <RenewButton />
          <BecomeProButtonIcon />
        </div>
      </div>
    </Container>
  );
};
